export default __webpack_public_path__ + "static/media/marketplace.544395ba.jpg";